import type { InventoryItem } from "../models/InventoryItem";
import type { KeyValue } from "../models/KeyValue";
import { CreateCrudService } from "./CrudServiceFactory";

export function InventoryService(warehouseCode?: string) {
  return CreateCrudService<InventoryItem, KeyValue>({
    PaginationInPath: true,
    WarehouseCode: warehouseCode,
    Route: "inventory",
    EntityName: "Inventory",
    PartialFields: ["ProductName", "ProductCode"],
    LoadingMessage: "Loading inventory...",
    SavingMessage: "Saving inventory...",
    MapPartial: (value) => ({
      Key: String(value.ProductCode ?? ""),
      Value: String(value.ProductName ?? ""),
    }),
  });
}
